module.exports = __webpack_public_path__ + "img/suitability-questionnaire.d967dd7a.svg";